import "./Pricing.module.css";
import Header from "@/reusable_sections/Header";
import OurTransparentPricingStructure from "./sections/OurTransparentPricingStructure";
import UnderstandingYourMigrationInvestment from "./sections/UnderstandingYourMigrationInvestment";
import Footer from "@/reusable_sections/Footer";
export default function PricingPage() {
  return <div>
      <Header />
      <OurTransparentPricingStructure />
      <UnderstandingYourMigrationInvestment />
      <Footer />
    </div>;
}